export class SamplingSimulationSegment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "subjectRows",
            "baseName": "subjectRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "keepProb",
            "baseName": "keepProb",
            "type": "number",
            "format": "double"
        },
        {
            "name": "weight",
            "baseName": "weight",
            "type": "number",
            "format": "double"
        },
        {
            "name": "relativeError",
            "baseName": "relativeError",
            "type": "number",
            "format": "double"
        },
        {
            "name": "floored",
            "baseName": "floored",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SamplingSimulationSegment.attributeTypeMap;
    }
    constructor() {
    }
}
